import { Modal } from "@mui/material";
import { LuTriangleAlert, LuX } from "react-icons/lu";
import "./DeleteConfirmationDialog.css";

const ROUTE_ENTITIES = {
  batgroup: "BAT group",
  buroles: "business role",
  contacts: "contact",
  creditnote: "credit note",
  customers: "customer",
  deliverytime: "delivery time",
  employees: "employee",
  expenses: "expense",
  invoicepdfformat: "invoice template",
  invoicereminder: "invoice reminder",
  invoices: "invoice",
  itemcategory: "item category",
  items: "item",
  loadvehicles: "load vehicle",
  myusers: "user",
  orders: "order",
  parameter: "parameter",
  parametersettings: "parameter setting",
  quotations: "quote",
  rcti: "RCTI",
  roles: "role",
  shipmentcharges: "shipment charge",
  standardplanfeature: "plan feature",
  subscriptionplan: "subscription plan",
  users: "user",
  vehicles: "vehicle",
  warehouse: "warehouse",
};

const inferRouteEntity = () => {
  if (typeof window === "undefined") return "";
  const segments = window.location.pathname
    .toLowerCase()
    .split("/")
    .filter(Boolean);
  const route = segments.find((segment) => ROUTE_ENTITIES[segment]);
  return route ? ROUTE_ENTITIES[route] : "";
};

function DeleteConfirmationDialog({
  open,
  closeModalClick,
  handleCancel,
  handleDelete,
  loading = false,
  message,
  heading,
  header,
  title,
  cancelLabel = "Cancel",
  confirmLabel,
  confirmTone = "danger",
  entityName,
  loadingLabel,
  error = "",
  mobileSheet = false,
  variant = "default",
  className = "",
}) {
  const suppliedMessage = message || heading || header;
  const isNonDeleteConfirmation = /set .*default|make .*default/i.test(
    suppliedMessage || ""
  );
  const entity = String(entityName || inferRouteEntity() || "").trim();
  const dialogTitle =
    title ||
    (isNonDeleteConfirmation
      ? "Confirm action"
      : entity
      ? `Delete ${entity}`
      : "Delete record");
  const body =
    suppliedMessage ||
    "Delete this record permanently? This action can’t be undone.";
  const actionLabel =
    confirmLabel ||
    (isNonDeleteConfirmation
      ? "Confirm"
      : entity
      ? `Delete ${entity}`
      : "Delete");
  const cancel = handleCancel || closeModalClick;
  const editorStyle = variant === "editor";

  return (
    <Modal
      open={Boolean(open)}
      onClose={loading ? undefined : closeModalClick || handleCancel}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
      className={`delete-dialog-modal${
        mobileSheet ? " settings-bottom-sheet-confirmation" : ""
      }${editorStyle ? " editor-delete-confirmation" : ""} ${className}`}
      slotProps={{
        backdrop: {
          className: `delete-dialog-backdrop${
            mobileSheet ? " settings-bottom-sheet-backdrop" : ""
          }`,
        },
      }}
    >
      <section className="delete-dialog" role="alertdialog">
        <header className="delete-dialog-header">
          {!editorStyle && <span className="delete-dialog-icon" aria-hidden="true">
            <LuTriangleAlert />
          </span>}
          <h2 id="delete-dialog-title">{dialogTitle}</h2>
          <button
            type="button"
            className="delete-dialog-close"
            aria-label="Close confirmation"
            disabled={loading}
            onClick={closeModalClick || handleCancel}
          >
            <LuX />
          </button>
        </header>
        {editorStyle ? (
          <div className="delete-dialog-content">
            <span className="delete-dialog-icon" aria-hidden="true"><LuTriangleAlert /></span>
            <p id="delete-dialog-description">{body}</p>
          </div>
        ) : <p id="delete-dialog-description">{body}</p>}
        {error && (
          <div className="delete-dialog-error" role="alert">
            {error}
          </div>
        )}
        <footer className="delete-dialog-actions">
          <button
            type="button"
            className="delete-dialog-button cancel"
            disabled={loading}
            onClick={cancel}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`delete-dialog-button ${
              isNonDeleteConfirmation || confirmTone === "primary" ? "confirm" : "danger"
            }`}
            disabled={loading}
            onClick={handleDelete}
          >
            {loading ? loadingLabel || "Deleting…" : actionLabel}
          </button>
        </footer>
      </section>
    </Modal>
  );
}

export default DeleteConfirmationDialog;
